// Locale formatting helpers (zh-CN) via Intl. No invented precision; real spec
// values only. F10 (build_review_001): prefer Intl.DateTimeFormat /
// Intl.RelativeTimeFormat over hand-rolled date math.

const relativeTimeFmt = new Intl.RelativeTimeFormat('zh-CN', { numeric: 'auto' });
const dateFmt = new Intl.DateTimeFormat('zh-CN', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});
const dateTimeFmt = new Intl.DateTimeFormat('zh-CN', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export function relativeTime(iso: string): string {
  const t = new Date(iso).getTime();
  const diffSec = Math.round((t - Date.now()) / 1000); // negative => past
  const min = Math.round(diffSec / 60);
  if (Math.abs(diffSec) < 60) return '刚刚';
  if (Math.abs(min) < 60) return relativeTimeFmt.format(min, 'minute');
  const hr = Math.round(min / 60);
  if (Math.abs(hr) < 24) return relativeTimeFmt.format(hr, 'hour');
  const day = Math.round(hr / 24);
  if (Math.abs(day) < 30) return relativeTimeFmt.format(day, 'day');
  return dateFmt.format(new Date(iso));
}

export function absoluteTime(iso: string): string {
  return dateTimeFmt.format(new Date(iso));
}

export function humanSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
